<!--
 * @Date: 2020-07
 * @LastEditTime: 2020-07-22 15:50
 * @Description:添加子账号 
-->  
<template>
  <div class="dialogBox">
    <el-dialog
      title="Edit"
      :visible.sync="showDialog"
      @close="clkCloseBtn"
      :close-on-click-modal="false"
      custom-class="borRad10"
      width="540px"
    >
      <el-form
        :model="accountInfo"
        :rules="rules"
        ref="accountInfo"
        class="resetCss font12"
      >
        <el-form-item label="Name：" prop="Name" label-width="150px">
          <el-input class="add-rInput" v-model="accountInfo.Name"></el-input>
        </el-form-item>
        <el-form-item label="Email：" prop="Email" label-width="150px">
          <el-input class="add-rInput" v-model="accountInfo.Email"></el-input>
        </el-form-item>
        <el-form-item label="Position：" prop="Position" label-width="150px">
          <el-input
            class="add-rInput"
            v-model="accountInfo.Position"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="Account permissions："
          prop="RightValue"
          label-width="150px"
        >
          <el-select
            style="width: 300px"
            v-model="accountInfo.RightValue"
            :placeholder="accountInfo.RightValueHolder"
          >
            <el-option
              v-for="item in accountInfo.RightValueOpt"
              :key="item.val"
              :label="item.label"
              :value="item.val"
            >
            </el-option>
          </el-select>
          <div
            v-if="accountInfo.RightValue === 1"
            style="font-size: 12px; line-height: 1.5"
          >
            Share my data, order, bill, etc
          </div>
          <div
            v-if="accountInfo.RightValue === 2"
            style="font-size: 12px; line-height: 1.5; width: 300px"
          >
            Can view the order data of himself/herself and subordinate users
          </div>
        </el-form-item>
        <el-form-item>
          <div style="text-align: center" class="marTop10">
            <a class="lineBlue30 marR20" @click="clkCloseBtn">CANCAL</a>
            <a
              class="blueBtn30"
              v-if="!isClick"
              @click="submitForm('accountInfo')"
              >SUMBIT</a
            >
            <a class="garyblueBtn30" v-if="isClick">SUMBIT</a>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { post, fetch } from "@/ask/axios";
import { elAlert } from "@/utils/bulletBox";
export default {
  data() {
    return {
      showDialog: false,
      userInfo: {},
      isClick: false, //是否有点击
      accountInfo: {
        Name: "",
        Email: "",
        Position: "",
        RightValue: "",
        NameHolder: "Please enter you name",
        EmailHolder: "Please enter you Email",
        PositionHolder: "Please enter you Position",
        RightValueHolder: "please select",
        RightValueOpt: [
          { label: "Same as Admin", val: 1 },
          { label: "User", val: 2 },
        ],
      },
      rules: {
        Name: [
          { required: true, message: "Please enter you name", trigger: "blur" },
          { min: 1, max: 100, message: "Maximum is 100 characters" },
        ],
        Email: [
          {
            required: true,
            message: "Please enter you Email",
            trigger: "blur",
          },
          { min: 1, max: 50, message: "Maximum is 50 characters" },
          {
            //pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, //正则
            pattern:
              /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i, //正则
            message: "Please enter a valid email address",
          },
        ],
        Position: [
          {
            required: true,
            message: "Please enter you Position",
            trigger: "blur",
          },
          { min: 1, max: 100, message: "Maximum is 100 characters" },
        ],
        RightValue: [
          { required: true, message: "please select", trigger: "change" },
        ],
      },
    };
  },
  mounted() {},
  created() {},
  methods: {
    resetData() {
      if (this.$refs["accountInfo"] !== undefined) {
        this.$refs["accountInfo"].resetFields();
      }
    },
    //显示弹窗  传入用户信息
    clkDialog(userInfo) {
      this.userInfo = userInfo;
      this.isLastLevel();
      this.showDialog = true;
      this.resetData();
    },
    isLastLevel() {
      if (this.userInfo.Level >= 4) {
        this.accountInfo.RightValueOpt = [{ label: "Same as Admin", val: 1 }];
        this.accountInfo.RightValue = 1;
      }
    },
    //关闭弹窗
    clkCloseBtn() {
      this.showDialog = false;
    },
    //调用新增接口
    addChildAccount() {
      let url = this.$api02 + "/api/EbayCustomer/WorkGroup/AddChildAccount";
      let level = this.userInfo.Level;
      if (this.accountInfo.RightValue === 2) {
        level++;
      }
      if (level >= 5) {
        return false;
      }
      let parma = {
        Name: this.accountInfo.Name,
        Email: this.accountInfo.Email,
        Position: this.accountInfo.Position,
        RightValue: this.accountInfo.RightValue,
        Level: level,
        RegisterSource: 10,
      };
      post(url, parma).then((res) => {
        this.isClick = false;
        if (res.IsOK) {
          elAlert(this, "success")
            .then(() => {
              this.clkCloseBtn();
              location.reload();
            })
            .catch(() => {
              this.clkCloseBtn();
              location.reload();
            });
        } else {
          // 调用bulletBox.js的方法
          let isEmailRe = false;
          if (res.Status) {
            res.Status.Errors.forEach((element) => {
              if (element.ErrorCode === "C0015") {
                isEmailRe = true;
              }
            });
            if (isEmailRe) {
              elAlert(this, "The Mailbox has been registered by another user");
            } else {
              elAlert(this, res.Message);
            }
          } else {
            elAlert(this, res.Message);
          }
        }
      });
    },
    // 校验
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isClick = true;
          this.addChildAccount();
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style>
</style>
<style scoped>
.garyblueBtn30 {
  display: inline-block;
  width: 100px;
  font-size: 12px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border: 1px solid #bbb;
  border-radius: 30px;
  background-color: #bbb;
  color: #fff !important;
}
.lineBlue30 {
  display: inline-block;
  width: 100px;
  font-size: 12px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border: 1px solid #004fb1;
  border-radius: 30px;
  background-color: #fff;
  color: #004fb1 !important;
}
.blueBtn30 {
  display: inline-block;
  width: 100px;
  font-size: 12px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border: 1px solid #004fb1;
  border-radius: 30px;
  background-color: #004fb1;
  color: #fff !important;
}
.addChild {
  padding: 10px 12px 0 12px;
}
.add-rInput {
  width: 300px;
  font-size: 12px;
}
.add-leftName {
  display: inline-block;
  width: 140px;
  text-align: right;
  font-size: 12px;
  color: #000;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/userCenter/public/basicInfo/addAccount.vue